module.exports = __webpack_public_path__ + "media/images/vp/samples/20-114bd16c51d24b1e4ff67645d77c6caa.jpg";